import {
  FormInput,
  Modal,
  FormBoolean,
} from "@frostbyte-technologies/frostbyte-tailwind";
import React, {Component} from "react";
import {Formik} from "formik";
import {setupReduxConnection} from "../../../redux";
import {request} from "../../../utils/request";
import * as Yup from "yup";
import {companyNameToSubdomain} from "../../../utils/util";

class MarketingModal extends Component {
  open() {
    this.setState({}, () => {
      this.formikRef && this.formikRef.resetForm();
      this.modal.open();
    });
  }

  handleSubmit = async ({fromName, user, subdomain, optIn, showTime}) => {
    const {onlyEmail} = this.props;
    const {companySettings} = this.props.shop;
    const companyPayload = {
      MARKETING_EMAIL_FROM:
        !fromName || fromName === "" ? null : fromName.trim(),
      MARKETING_EMAIL_USER:
        !user || user.trim() === "" ? "marketing" : user.trim(),
      MARKETING_EMAIL_SUBDOMAIN:
        !subdomain || subdomain === "" ? null : subdomain.trim(),
    };

    if (!onlyEmail) {
      companyPayload.EXPIRATION_DATE_FORMAT =
        showTime === "0" ? "MM/DD/YY" : "MM/DD/YY hh:mm a";
    }

    await request("settings/company", "PATCH", {
      SETTINGS: companyPayload,
    });

    if (!onlyEmail) {
      let payload = {
        TEXT_MARKETING_OPT_IN: optIn,
      };

      await request("partner/settings/v2", "PATCH", {SETTINGS: payload});
    }

    let settings = await request("settings/shop", "GET");

    this.props.updateShop({
      settings,
      companySettings: {...companySettings, ...companyPayload},
    });

    this.modal.close();
  };

  render() {
    const {companyName, onlyEmail} = this.props;

    const {
      MARKETING_EMAIL_USER,
      MARKETING_EMAIL_FROM,
      MARKETING_EMAIL_SUBDOMAIN,
      EXPIRATION_DATE_FORMAT,
    } = this.props.shop.companySettings;
    const {TEXT_MARKETING_OPT_IN} = this.props.shop.settings;

    return (
      <Modal
        label="Marketing Settings"
        buttonLabel="Save"
        formikOnClick={() => this.formikRef}
        ref={(e) => (this.modal = e)}
      >
        <Formik
          onSubmit={this.handleSubmit}
          innerRef={(e) => (this.formikRef = e)}
          // TODO yup validation for these names i.e. no slashes or numbers etc where applicable
          initialValues={{
            fromName: MARKETING_EMAIL_FROM || companyName,
            user: MARKETING_EMAIL_USER,
            subdomain:
              MARKETING_EMAIL_SUBDOMAIN || companyNameToSubdomain(companyName),
            optIn: TEXT_MARKETING_OPT_IN,
            showTime: EXPIRATION_DATE_FORMAT === "MM/DD/YY hh:mm a" ? "1" : "0",
          }}
        >
          {(formikOptions) => {
            const {handleSubmit} = formikOptions;

            return (
              <form onSubmit={handleSubmit}>
                <FormInput
                  name="fromName"
                  label="Display Name"
                  options={formikOptions}
                />

                <FormInput
                  name="user"
                  label="Email User"
                  options={formikOptions}
                />

                <FormInput
                  name="subdomain"
                  label="Subdomain"
                  options={formikOptions}
                />

                {!onlyEmail && (
                  <>
                    <FormBoolean
                      name="optIn"
                      label="Display Text Marketing Opt In"
                      options={formikOptions}
                    />

                    <FormBoolean
                      name="showTime"
                      label="Show Time on Expiration Text"
                      options={formikOptions}
                    />
                  </>
                )}
              </form>
            );
          }}
        </Formik>
      </Modal>
    );
  }
}

export default setupReduxConnection(["shop"], null, {forwardRef: true})(
  MarketingModal
);
